import { render, staticRenderFns } from "./ClassicModule.vue?vue&type=template&id=3bc6e5e5&scoped=true"
import script from "./ClassicModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassicModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClassicModule.vue?vue&type=style&index=0&id=3bc6e5e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6e5e5",
  null
  
)

export default component.exports